export enum LoginType {
    EmailChange = "email_change",
    NewUser = "new_user",
    ReturningUser = "returning_user",
}
